// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from  '@src/@core/auth/jwt/urls'
import { errorToast, sucessToast } from '../../../components/messageToast/messageToast'
// ** Axios Imports
import axios from 'axios'
const qs = require('qs')
// import { errorToast, sucessToast } from '../../../components/messageToast/messageToast'
// const qs = require('qs')

//********************   PAYMENTS    ****************************
export const getAllPayments = createAsyncThunk('appPayments/getAllPayments', async (params) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceGet.get(`/customers/payments/`, {params: {p:params.page, idCustomer:params.idCustomer, id:params.document, start:params.start, end:params.end, method:params.method}})
  return response
})

export const getPaymentByID = createAsyncThunk('appPayments/getPaymentByID', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instance.get(`/customers/payments/${id}/get_payment/`)
  return response.data
})

export const deletePaymentByID = createAsyncThunk('appPayments/deletePaymentByID', (params, { dispatch }) => {
  const instance2 = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/x-www-form-urlencoded"}
  })
  instance2.post(`/customers/payments/delete_payment/`, qs.stringify({id_payment:params.id_payment}))
      .then(async resp => {
        sucessToast("Pago se elimino correctamente")
        await dispatch(getAllPayments(params.getData))
        return resp.data
      })
      .catch((err) => {
        if (err?.response?.data?.error) {
          errorToast(err.response.data.msg)
        } else {
          errorToast("Pago no se elimino correctamente")
        }
      })
})


//********************   PAYMENTS DETAILS   ****************************
export const getAllData = createAsyncThunk('appPayments/getAllData', async (params) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceGet.get(`/customers/payments_details/`, {params: {p:params.page, idCustomer:params.idCustomer, id:params.document, start:params.start, end:params.end, method:params.method}})
  return response
})

export const getPayment = createAsyncThunk('appPayments/getPayment', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  
  const response = await instance.get(`/customers/payments_details/${id}/`)
  return response.data
})

export const updatePayment = createAsyncThunk('appPayments/updatePayment', (params, { dispatch }) => {
  const instance2 = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/x-www-form-urlencoded"}
  })
  instance2.post(`/customers/payments_details/update_payment/`, qs.stringify(params.payment))
    .then(async resp => {
      await dispatch(getPayment(params.payment.id))
      sucessToast("Pago se modifico correctamente")
      return resp.data
    })
    .catch((err) => {
      if (err?.response?.data?.error) {
        errorToast(err.response.data.msg)
      } else {
        errorToast("Pago no se modifico correctamente")
      }
    })
})


export const deletePayment = createAsyncThunk('appPayments/deletePayment', (params, { dispatch }) => {
  const instance2 = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/x-www-form-urlencoded"}
  })
  instance2.post(`/customers/payments_details/delete_payment/`, qs.stringify({id_payment_detail:params.id_payment_detail}))
    .then(async resp => {
      sucessToast("Pago se elimino correctamente")
      await dispatch(getAllData(params.getData))
      return resp.data
    })
    .catch((err) => {
      if (err?.response?.data?.error) {
        errorToast(err.response.data.msg)
      } else {
        errorToast("Pago no se elimino correctamente")
      }
    })
})

export const setIsFetchingResults = createAsyncThunk('appPayments/setIsFetchingResults', () => {
  return "fetching"
})

export const cleanPayments = createAsyncThunk('appPayments/cleanPayments', () => {
  return "clean"
})

export const appPaymentsSlice = createSlice({
  name: 'appPayments',
  initialState: {
    allData: [],
    total: 1,
    selectedPayment: null,
    selectedPaymentByID : {},
    isFetching: false,
    isEditable: 'view'
  },
  reducers: {
    setIsEditable: (state, action) => {
      state.isEditable = action.payload
      // console.log('isEditable set to:', state.isEditable) //--- IGNORE ---
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload.data.results
        state.total = action.payload.data.count
        state.isFetching = false
      })
      .addCase(getAllPayments.fulfilled, (state, action) => {
        state.allData = action.payload.data.results
        state.total = action.payload.data.count
        state.isFetching = false
      })
      .addCase(getPaymentByID.fulfilled, (state, action) => {
        state.selectedPaymentByID = action.payload
      })
      .addCase(getPayment.fulfilled, (state, action) => {
        state.selectedPayment = action.payload
      })

      .addCase(cleanPayments.fulfilled, (state) => {
        state.allData = []
        state.total = 1
      })
      .addCase(setIsFetchingResults.fulfilled, (state) => {
        state.isFetching = true
      })

  }
})

export const { setIsEditable } = appPaymentsSlice.actions
export default appPaymentsSlice.reducer
